export const APP_BASE: string = import.meta.env.BASE_URL || '/';

export const APP_BASE_NO_SLASH: string = APP_BASE === '/'
	? ''
	: APP_BASE.replace(/\/+$/, '');

export const IS_V2: boolean = APP_BASE.startsWith('/v2/') || APP_BASE === '/v2';

export const getPathWithoutBase = (): string => {
	if (typeof window === 'undefined') {
		return '/';
	}
	const pathname = window.location.pathname;
	if (APP_BASE === '/' || APP_BASE === '') {
		return pathname;
	}
	if (pathname.startsWith(APP_BASE)) {
		const rest = pathname.slice(APP_BASE.length);
		return rest.startsWith('/') ? rest : `/${rest}`;
	}
	return pathname;
};

export const hasUstawotekaPathPrefix = (): boolean => {
	const path = getPathWithoutBase();
	return path === '/ustawoteka' || path.startsWith('/ustawoteka/');
};
